<template>
  <v-row>
    <v-col sm="12" mt-3>
      <v-tabs v-model="activeTab" :background-color="`${theme.primaryColor} lighten-5`">
        <v-tab ripple>Clarification Needed ({{ clarificationNeededCount }})</v-tab>
        <v-tab ripple>Reopened ({{ reopenedCount }})</v-tab>
        <v-tab ripple>In Process ({{ inProcessCount }})</v-tab>
        <v-tab ripple>Pending Peer Review ({{ pendingPeerReviewCount }})</v-tab>
        <v-tab ripple>Corrections Indicated ({{ correctionsIndicatedCount }})</v-tab>
        <v-tab ripple>Ready to Publish ({{ readyToPublishCount }})</v-tab>
        <v-tab ripple>Published ({{ publishedCount }})</v-tab>
        <v-tab ripple>Pending Review ({{ pendingReviewCount }})</v-tab>
        <v-tab ripple>Cancelled ({{ cancelledCount }})</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item eager>
          <documentation-status-list
            status="Clarification Needed"
            title="Clarification Needed"
            :packId="$route.params.packId"
            @noteCount="getClarificationNeededCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Reopened"
            title="Reopened"
            :packId="$route.params.packId"
            @noteCount="getReopenedCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="In Process"
            title="In Process"
            :packId="$route.params.packId"
            @noteCount="getInProcessCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Pending Peer Review"
            title="Pending Peer Review"
            :packId="$route.params.packId"
            @noteCount="getPendingPeerReviewCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Corrections Indicated"
            title="Corrections Indicated"
            :packId="$route.params.packId"
            @noteCount="getCorrectionsIndicatedCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Ready to Publish"
            title="Ready to Publish"
            :packId="$route.params.packId"
            @noteCount="getReadyToPublishCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Published"
            title="Published"
            :packId="$route.params.packId"
            @noteCount="getPublishedCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Pending Review"
            title="Pending Review"
            :packId="$route.params.packId"
            @noteCount="getPendingReviewCount"
          >
          </documentation-status-list>
        </v-tab-item>
        <v-tab-item eager>
          <documentation-status-list
            status="Cancelled"
            title="Cancelled"
            :packId="$route.params.packId"
            @noteCount="getCancelledCount"
          >
          </documentation-status-list>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import DocumentationStatusList from "@/components/documentationStatusList";

export default {
  components: {
    DocumentationStatusList,
  },
  computed: {
    activeTab: {
      get() {
        const { tab } = this.$route.query;
        const index = this.tabs.indexOf(tab);
        return index < 0 ? 0 : index;
      },
      set(index) {
        const tab = this.tabs[index];
        this.$router.push({ query: { tab } });
      },
    },
    packId() {
      return this.$route.params.packId;
    },
    theme() {
      return this.$store.state.session.theme;
    },
  },
  data() {
    return {
      pendingPeerReviewCount: 0,
      cancelledCount: 0,
      clarificationNeededCount: 0,
      correctionsIndicatedCount: 0,
      inProcessCount: 0,
      pendingReviewCount: 0,
      publishedCount: 0,
      readyToPublishCount: 0,
      reopenedCount: 0,
      tabs: [
        "clarification-needed",
        "reopened",
        "in-process",
        "pending-peer-review",
        "corrections-indicated",
        "ready-to-publish",
        "published",
        "pending-review",
        "cancelled",
      ],
    };
  },
  methods: {
    getCancelledCount(val) {
      this.cancelledCount = val;
    },
    getClarificationNeededCount(val) {
      this.clarificationNeededCount = val;
    },
    getCorrectionsIndicatedCount(val) {
      this.correctionsIndicatedCount = val;
    },
    getInProcessCount(val) {
      this.inProcessCount = val;
    },
    getPendingReviewCount(val) {
      this.pendingReviewCount = val;
    },
    getPublishedCount(val) {
      this.publishedCount = val;
    },
    getReadyToPublishCount(val) {
      this.readyToPublishCount = val;
    },
    getReopenedCount(val) {
      this.reopenedCount = val;
    },
    getPendingPeerReviewCount(val) {
      this.pendingPeerReviewCount = val;
    },
  },
};
</script>
